// import logo from './logo.svg';
import "./App.css";
import Home from "./components/home/home";
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";
import Services from "./components/services/services";
import RegisterAsProfessional from "./components/register-as-professional/registerAsProfessional";
import Blogs from "./components/blogs/blogs";
import BlogsInr from "./components/blogs-inr/blogsInr";
import Subscription from "./components/subscription/subscription";
import Nearme from "./components/nearme/nearme";
import AboutUs from "./components/about-us/aboutUs";
import PrivacyPolicy from "./components/privacy-policy/privacyPolicy";
import TermsAndConditions from "./components/terms-conditions/termsAndConditions";
import Order from "./components/order/order";
// import { onAuthStateChanged } from "@firebase/auth";
// import { auth } from "./firebase";
// import { useEffect } from "react";
import ScrollToTop from "./components/utils/ScrollToTop";
import { AuthContextProvider } from "./auth/useAuth";
import ServicesList from "./components/services/ServicesList";
import FullBlogPage from "./components/blogs/FullBlogPage";

const App = () => {
  // useEffect(() => {
  //   const unsubscribe = onAuthStateChanged(auth, (user) => {
  //     console.log({ user });
  //   });

  //   return () => unsubscribe();
  // }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div>
        <AuthContextProvider>
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/registerAsProfessional">
              <RegisterAsProfessional />
            </Route>
            <Route exact path="/services">
              <ServicesList />
            </Route>
            <Route exact path="/services/:service_id">
              <Services />
            </Route>
            <Route path="/nearme">
              <Nearme />
            </Route>
            <Route exact path="/blogs">
              <Blogs />
            </Route>
            <Route exact path="/blogs/:blogId">
              <FullBlogPage />
            </Route>
            <Route exact path="/subscription">
              <Subscription />
            </Route>
            <Route exact path="/aboutus">
              <AboutUs />
            </Route>
            <Route exact path="/privacy">
              <PrivacyPolicy />
            </Route>
            <Route exact path="/terms">
              <TermsAndConditions />
            </Route>
            <Route exact path="/order">
              <Order />
            </Route>
          </Switch>
        </AuthContextProvider>
      </div>
    </BrowserRouter>
  );
};

export default App;
